// @flow
import React from 'react';
import { Flex } from '@rebass/grid';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { navigate } from '@reach/router';
import warningImg from 'images/warning.svg';
import successImg from 'images/check.svg';
import { API_ROOT } from 'api/config';
// import {replace} from 'formik'

/* todo: Refactor this after URL constants */
function sanitizeUrl(url) {
  const urlParts = url.split('?');

  if (!urlParts[0].endsWith('/')) {
    urlParts[0] += '/';
  }
  return urlParts.join('?');
}

export function parseError(error: string): string {
  return error || 'Something went wrong';
}

const returnToastIcon = icon => `
    width: 22px;
    height: 22px;
    background: url(${icon}) no-repeat;
    background-size: 22px;
    background-position: 0px 0px;
`;

const warningIcon = styled.div`
  ${returnToastIcon(warningImg)}
`;
const successIcon = styled.div`
  ${returnToastIcon(successImg)}
`;

const iconTypes = {
  warning: warningIcon,
  success: successIcon
};

export const pushToast = config => {
  const type = config.type || 'success';
  const IconType = iconTypes[type];
  toast[type](
    <Flex css={{ minHeight: '64px' }}>
      <ToastSection
        justifyContent="center"
        alignItems="center"
        className="icon-wrapper"
        width={1 / 4}
      >
        <IconType />
      </ToastSection>
      <ToastSection
        alignItems="center"
        css={{
          padding: '10px'
        }}
        width={3 / 4}
      >
        {config.message}
      </ToastSection>
    </Flex>
  );
};

export default function request(
  url: string,
  options: Object = {},
  skipAccountId,
  skipAuthToken
): Promise<*> {
  const config = {
    method: 'GET',
    isEmptyPayload: false,
    ...options
  };
  const errors = [];

  if (!url) {
    errors.push('url');
  }

  if (
    !config.payload &&
    !config.isEmptyPayload &&
    (config.method !== 'GET' && config.method !== 'DELETE')
  ) {
    errors.push('payload');
  }

  if (errors.length) {
    throw new Error(`Error! You must pass \`${errors.join('`, `')}\``);
  }
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(!skipAuthToken && {
      Authorization: `token ${localStorage.getItem('auth-token')}`
    }),
    ...config.headers,
    ...(!skipAccountId && {
      'freshstatus-account-id': localStorage.getItem('active-account')
    })
  };

  const params: Object = {
    headers,
    method: config.method
  };

  if (params.method !== 'GET') {
    params.body = JSON.stringify(config.payload);
  }

  return fetch(`${API_ROOT}${sanitizeUrl(url)}`, params).then(
    async response => {
      if (response.status > 299) {
        const contentType = response.headers.get('content-type');
        switch (response.status) {
          case 401:
          case 403:
            // pushToast({
            //   message: 'Authentication failed.',
            //   type: 'warning',
            // })
            localStorage.clear();
            setTimeout(() => {
              navigate('/admin');
            }, 4000);
            break;
          case 405:
            pushToast({
              message: 'Operation is not permitted',
              type: 'warning'
            });
            break;
          case 422:
            pushToast({
              message: response.message
                ? response.message
                : 'Cannot perform action',
              type: 'warning'
            });
            break;
          case 503:
            pushToast({
              message: 'Oops... Something went wrong.',
              type: 'warning'
            });
            break;
          default:
            break;
        }
        if (response.status === 404) {
          return { status: response.status };
        }

        if (response.status === 400) {
          const responseJson = await response.json();
          return {
            response: responseJson,
            status: response.status,
            error: true
          };
        }
        const error = { status: response.statusText };

        if (contentType && contentType.includes('application/json')) {
          error.response = {
            status: response.status,
            data: await response.json()
          };
        } else {
          error.response = {
            status: response.status,
            data: await response.text()
          };
        }

        throw error;
      } else {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          if (config.toast) {
            pushToast(config.toast);
          }
          return response.json();
        }

        return response.text();
      }
    }
  );
}

const ToastSection = styled(Flex)``;
